<div class="skl-ai-connections" aria-busy="true" aria-label="Loading AI connections">
  <app-skeleton width="220px" height="18px" borderRadius="4px" marginBottom="16px" class="d-block"></app-skeleton>

  <div class="skl-header-copy">
    <app-skeleton width="360px" height="13px" borderRadius="3px" marginBottom="8px"></app-skeleton>
    <app-skeleton width="280px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
  </div>

  <div class="skl-toolbar">
    <app-skeleton width="170px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
  </div>

  <div class="skl-card">
    <div class="skl-card__body">
      <app-skeleton width="180px" height="18px" borderRadius="4px" marginBottom="20px"></app-skeleton>

      <div class="skl-table-wrap">
        <div class="skl-row skl-row--header">
          @for (col of tableCols; track col) {
            <div class="skl-cell">
              <app-skeleton [width]="col === 1 ? '70%' : col === 6 ? '60%' : '80%'" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
            </div>
          }
        </div>

        @for (row of tableRows; track row) {
          <div class="skl-row skl-row--data">
            @for (col of tableCols; track col) {
              <div class="skl-cell">
                @if (col === 6) {
                  <div class="skl-actions">
                    <app-skeleton width="58px" height="28px" borderRadius="4px" marginBottom="0"></app-skeleton>
                    <app-skeleton width="64px" height="28px" borderRadius="4px" marginBottom="0"></app-skeleton>
                  </div>
                } @else {
                  <app-skeleton [width]="col === 1 ? '58%' : col === 2 ? '86%' : col === 3 ? '52%' : col === 4 ? '60%' : '48%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>